module.exports = __webpack_public_path__ + "5becd3dc2af519e0290ef99a706d4f7b.fbx";